import { render, staticRenderFns } from "./EnergyConsumption.vue?vue&type=template&id=e872faf4&scoped=true&"
import script from "./EnergyConsumption.vue?vue&type=script&lang=ts&"
export * from "./EnergyConsumption.vue?vue&type=script&lang=ts&"
import style0 from "./EnergyConsumption.vue?vue&type=style&index=0&id=e872faf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e872faf4",
  null
  
)

export default component.exports